import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=4fdd32be&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=4fdd32be&prod&lang=css&scoped=true"
import style1 from "./SearchPage.vue?vue&type=style&index=1&id=4fdd32be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd32be",
  null
  
)

export default component.exports